import { HomeFeedApi } from '../../generated/api';
import configuration from './configuration';

const homeFeedService = new HomeFeedApi(configuration);

export default homeFeedService;
